/* eslint-disable tss-unused-classes/unused-classes */
import { Checkbox, FormControlLabel } from '@mui/material'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { MaterialSummaryDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { makeStyles } from 'tss-react/mui'

type Props = {
  usingArticleCatalog: boolean
  handleChangeUseArticleCatalog: (useArticleCatalog: boolean) => void
  selectedArticle: MaterialSummaryDto
}

const useStyle = makeStyles({ name: 'usingArticleCatalog' })((theme) => ({
  articleDescription: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    textAlign: 'left',
  },
  root: {
    '& .MuiFormControlLabel-root': {
      padding: theme.spacing(0.5, 0.5),
      borderRadius: theme.shape.borderRadius,
    },
  },
}))

export const CustomPriceOrArticleCatalogPriceSwitch = (props: Props) => {
  const { classes } = useStyle()
  return (
    <div>
      <div className={classes.root}>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.usingArticleCatalog}
              onChange={(e, checked) =>
                props.handleChangeUseArticleCatalog(checked)
              }
              size="small"
            />
          }
          labelPlacement="end"
          color="primary"
          label={
            <LocalizedTypography
              translationKey="project:purchasing-data-use-prices-from-article"
              variant="caption"
            >
              use prices from article catalog
            </LocalizedTypography>
          }
        />
      </div>
    </div>
  )
}
